import React, { useEffect } from 'react';
import { MapContainer } from '@components/organism/MapContainer';
import { Map } from '@components/atoms/Map';
import { CarSearchWithPicker } from '@components/organism/CarSearchWithPicker/CarSearchWithPicker';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import styles from './MapPage.module.css';
import { useNavigate } from 'react-router-dom';
import { useData } from '@hooks/useData';
import { AvailabilityWithPicker } from '@components/organism/AvailabilityWithPicker/AvailabilityWithPicker';
import { SITE_URLS } from '@constants';
import { useRoleChecker } from '@hooks/useRoleChecker';

export function MapPage() {
    const navigate = useNavigate();
    const { login } = useData();
    const { isDriver } = useRoleChecker();

    useEffect(() => {
        if (!login) {
            navigate(`/${SITE_URLS.login}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    return (
        <MapContainer>
            <div className="position-relative w-100 h-100">
                <Map locations={[]} style={JSON.stringify({ height: '100%', width: '100%' })} />

                <div className="position-absolute top-0 z-3 p-4">
                    <RoundIcon
                        classes={styles.roundIcon}
                        icon="fa-thin fa-bars"
                        variant={RoundIconVariants.variant1}
                        onClick={() => navigate('/my-profile')}
                    />
                </div>

                <div className="position-absolute bottom-0 w-100 z-2">
                    {isDriver ? <AvailabilityWithPicker /> : <CarSearchWithPicker />}
                </div>
            </div>
        </MapContainer>
    );
}
